import { ApiError } from "./ApiError";

export default class NotFoundError extends ApiError {
  code = 404;
}
